
import React from "react";
import moment from "moment-timezone";
import { Row, Col } from '@themesberg/react-bootstrap';

export default () => {
  const currentYear = moment().get("year");

  return (
    <footer className="footer section py-4">
      <Row>
        <Col xs={12} className="text-center">
          <p className="mb-0 text-muted">
            © {currentYear} WekaRecords
          </p>
        </Col>
      </Row>
    </footer>
  );
};
